// For the wishlist icon reload
   document.addEventListener("DOMContentLoaded", function() {

    // 1. Define the "Fix" Logic (The Painter & The Electrician)
    // We put this in a function so we can reuse it easily.
    function reinitWishlistButtons() {
        if (typeof BlsSubActionProduct !== 'undefined') {
            console.log("Cart content changed. Re-initializing Wishlist...");
            
            // Restore the Red Hearts (The Painter)
            BlsSubActionProduct.handleInitWishlist();
            
            // Restore the Click Functionality (The Electrician)
            BlsSubActionProduct.handleActionWishlist();
        }
    }

    // 2. Define the "Security Camera" Setup
    // This function takes a class name, finds it, and attaches the observer.
    function attachObserverTo(selector) {
        const targetElement = document.querySelector(selector);

        // If this element isn't on the current page, stop here.
        if (!targetElement) return;

        const observer = new MutationObserver(function(mutations) {
            
            // A. Turn off the camera (Prevent infinite loops)
            observer.disconnect();

            // B. Run the Fix
            reinitWishlistButtons();

            // C. Turn the camera back on after 100ms
            setTimeout(() => {
                observer.observe(targetElement, { childList: true, subtree: true });
            }, 100);
        });

        // Start watching immediately
        observer.observe(targetElement, { childList: true, subtree: true });
    }

    // ---------------------------------------------
    // 3. EXECUTE: Turn on the cameras for your specific areas
    // ---------------------------------------------

    // Watch the Mini Cart (Home Page / Global)
    attachObserverTo(".bls-minicart-wrapper");

    // Watch the Main Cart Page
    attachObserverTo(".cart-wrapper");

});

//     if(window.location.pathname === "/cart") {
//         document.addEventListener("click", deleteElement);
//     }

// function deleteElement(e) {
//     console.log("Clicked");
//     if(!e.target.closest(".bls__product-wishlist-js")) return;
//                    const element = e.target.closest(".bls__product-wishlist-js");
//                if(!element) return;
//                    const button = element.querySelector(`span.bls__product-icon`);
//                    if(!button) return;
//                if(button.classList.contains("active")){
//                     window.location.href = element.dataset.hrefUrl;
//                }
// }
